import { MainTabsV2 } from '@labrav/react-components'
import { lazy, Suspense, useMemo } from 'react'
import { useStyles } from './FlyOutOnboardingWrapper.styles'
import microsoft from '../../common/images/microsoft_x_small.png'
import aws from '../../common/images/awsXSmall.png'
import { useFlagValue } from '@labrav/flags'
import { v4 as uuidv4 } from 'uuid'
import { Route, Routes } from 'react-router-dom'
import { settingsTabs } from './settingsTabs'
import { FlyoutBlockPage } from '../../common/components/FlyoutBlockPage'
import { useSelector } from '../../store'
import { AccountData } from '../../types/external'

type FlyoutSubscribedProducts = {
  FLYOUT?: { cloudProviders?: string[] }
}

const FlyOutAwsOnboarding = lazy(
  () => import('./FlyOutAwsOnboarding/FlyOutAwsOnboarding')
)
const FlyOutMicrosoftOnboarding = lazy(
  () => import('./FlyOutMicrosoftCloudSettings/FlyOutMicrosoftCloudSettings')
)

export const FlyoutOnboardingWrapper = () => {
  const { classes } = useStyles()
  const windowId = uuidv4()
  if (!window.name) {
    window.name = windowId
  }
  const { value: isMicrosoftMarketplaceOnboardingEnabled } = useFlagValue(
    'microsoftMarketplaceOnboarding'
  )

  const partnerData = useSelector<AccountData | undefined>(
    state => state.AccountData.user.partnerData || undefined
  )

  const customerData =
    partnerData?.subscribedProducts as Partial<FlyoutSubscribedProducts>
  const flyoutProduct = customerData?.FLYOUT
  const flyoutSubscribedCloudProviders = flyoutProduct?.cloudProviders || []

  const cloudTypeTabs = useMemo(
    () => [
      {
        label: 'AWS',
        icon: <img src={aws} alt="AWS" className={classes.awsImage} />,
        key: 'aws',
        path: 'aws',
        component: flyoutSubscribedCloudProviders?.includes('AWS')
          ? FlyOutAwsOnboarding
          : () => <FlyoutBlockPage showHeader={false} />,
      },
      {
        label: 'Microsoft',
        icon: (
          <img
            src={microsoft}
            alt="Microsoft"
            className={classes.microsoftImage}
          />
        ),
        key: 'microsoft',
        path: 'microsoft',
        component: flyoutSubscribedCloudProviders?.includes('AZURE')
          ? FlyOutMicrosoftOnboarding
          : () => <FlyoutBlockPage showHeader={false} />,
        disabled: !isMicrosoftMarketplaceOnboardingEnabled,
        tootTipText: isMicrosoftMarketplaceOnboardingEnabled
          ? ''
          : 'Coming soon',
      },
    ],
    [
      classes.awsImage,
      classes.microsoftImage,
      isMicrosoftMarketplaceOnboardingEnabled,
    ]
  )

  const { activeTab, handleTabChange, settingsTabsForRouting } = settingsTabs(
    [],
    cloudTypeTabs,
    true,
    false
  )

  return (
    <>
      <div
        className={classes.tabContainer}
        data-testid="flyout-onboarding-tab-container"
      >
        <MainTabsV2
          tabs={cloudTypeTabs}
          activeTabIndex={activeTab}
          onChange={handleTabChange}
          tabsType={'main'}
        />
      </div>
      <div
        className={classes.mainContainer}
        data-testid="flyout-onboarding-main-container"
      >
        <Suspense fallback={<div />}>
          <Routes>
            {settingsTabsForRouting.map(t => {
              const Comp = t.component
              return (
                <Route
                  key={t.path}
                  path={t.path}
                  element={Comp ? <Comp /> : <></>}
                />
              )
            })}
          </Routes>
        </Suspense>
      </div>
    </>
  )
}
